import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import WarningBanner from '../../components/WarningBanner';
import {
  CANNOT_SPLIT,
  SELECT_ALL_REMAINING_PARCELS,
  UNABLE_TO_SPLIT_CONSIGNMENT_PARCELS,
} from '../../constants/strings';
import { parcelsWithSameConsignmentValues } from '../../models/editStop';
import { onSelectParcels } from '../../store/reducers/ui/routeDetail/selectedParcels';

const ConsignmentRestrictions = ({
  selectedParcels,
  remainingParcels = [],
  withActionButton = true,
}) => {
  const dispatch = useDispatch();
  const message = useMemo(() => {
    if (!withActionButton) {
      return UNABLE_TO_SPLIT_CONSIGNMENT_PARCELS;
    }
    return remainingParcels.length
      ? UNABLE_TO_SPLIT_CONSIGNMENT_PARCELS
      : CANNOT_SPLIT;
  }, [remainingParcels.length, withActionButton]);
  const fixSplitConsignment = useCallback(() => {
    const consignmentParcels = parcelsWithSameConsignmentValues(
      selectedParcels,
      remainingParcels
    );
    dispatch(onSelectParcels(consignmentParcels));
  }, [selectedParcels, remainingParcels, dispatch]);

  return (
    <WarningBanner
      message={message}
      onActionClick={
        withActionButton && remainingParcels.length ? fixSplitConsignment : null
      }
      actionTitle={SELECT_ALL_REMAINING_PARCELS}
    />
  );
};

export default memo(ConsignmentRestrictions);
